import axios from 'axios'

var backend = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
})

var synopsis_backend = axios.create({
  baseURL: process.env.VUE_APP_SYNOPSIS_API_URL
})

const _makeRequest = (method, url, data) => {
  return new Promise((resolve, reject) => {
    var res
    if(method === 'get'){
      res = backend.get(url, data, {})
    } else if(method === 'post'){
      res = backend.post(url, data, {})
    } else {
      throw `$'{method}' method not implemented.`
    }
    res.then(res2 => {
      resolve(res2.data)
    }, err => {
      console.error(err)
      reject(err)
    })   
  })
}

const get_latest = function (court) {
  // Home.vue
  return _makeRequest('get', 'getlatest', {
    params: {court: court}
  })
}

const autocomplete = function (field, text) {
  // AdvancedSearch.vue, Home.vue
  return _makeRequest('get', 'autocomplete', {
    params: {field: field, text: text}
  })
}

const get_legisfiles = function (params) {
  // LegisDb.vue
  var params_no_null = {}
  Object.keys(params).forEach((item) => {
    if (params[item]) { params_no_null[item] = params[item] }
  })
  return _makeRequest('get', 'getlegisfiles', {
    params: params_no_null
  })
}

const get_legisname = function (params) {
  // searchResults.vue
  var params_no_null = {}
  Object.keys(params).forEach((item) => {
    if (params[item]) { params_no_null[item] = params[item] }
  })
  return _makeRequest('get', 'getlegisname', {
    params: params_no_null
  })
}

const get_cap = function (lang, cap, abbr) {
  // SectionToc.vue
  return _makeRequest('get', 'getcap', {
    params: {lang: lang, cap: cap, abbr: abbr}
  })
}

const get_related_caps = function (num_int, lang, abbr) {
  // SectionToc.vue
  return _makeRequest('get', 'getrelatedcaps', {
    params: {num_int: num_int, lang: lang, abbr: abbr}
  })
}

const get_capversions = function (lang, cap) {
  // SectionToc.vue
  return _makeRequest('get', 'getcapversions', {
    params: {lang: lang, cap: cap}
  })
}

const get_secversions = function (lang, abbr, cap, subpath) {
  // Section.vue
  return _makeRequest('get', 'getsecversions', {
    params: {lang: lang, abbr: abbr, cap: cap, subpath: subpath}
  })
}

const get_capversiontoc = function (id) {
  // SectionToc.vue
  return _makeRequest('get', 'getcapversiontoc', {
    params: {id: id}
  })
}

const get_sectionnav = function (id, order) {
  // Section.vue
  return _makeRequest('get', 'getsectionnav', {
    params: {id: id, order: order}
  })
}

const get_capsection = function (vid, subpath) {
  // Section.vue
  return _makeRequest('get', 'getcapsection', {
    params: {vid: vid, subpath: subpath}
  })
}

const advanced_search = function (params) {
  // SearchResults.vue
  var params_no_null = {}
  Object.keys(params).forEach((item) => {
    if (params[item]) { params_no_null[item] = params[item] }
  });
  return _makeRequest('get', 'advancedsearch', {params: params_no_null})
}

const simple_search = function (searchstring, disablefuzzy) {
  // SearchResults.vue
  return _makeRequest('get', 'simplesearch', {
    params: {searchstring: searchstring, disablefuzzy: disablefuzzy}
  })
}

const get_appeal_history = function (caseno) {
  // AppealHistory.vue
  return _makeRequest('get', 'getappealhistory', {
    params: {caseno: caseno}
  })
}

const get_metalegis = function (cap_type, lang) {
  // LeggisDb.vue
  return _makeRequest('get', 'getmetalegis', {
    params: {cap_type: cap_type, lang: lang}
  })
}

const get_metacase = function (caseDb, lang) {
  // CaseDb.vue
  return _makeRequest('get', 'getmetacase', {
    params: {caseDb: caseDb, lang: lang}
  })
}

const get_casefiles = function (params) {
  // CaseDb.vue
  var params_no_null = {}
  Object.keys(params).forEach((item) => {
    if (params[item]) { params_no_null[item] = params[item] }
  });
  return _makeRequest('get', 'getcasefiles', {
    params: params_no_null
  })
}

const get_hoptfiles = function (params) {
  // TreatyDb.vue
  var params_no_null = {}
  Object.keys(params).forEach((item) => {
    if (params[item]) { params_no_null[item] = params[item] }
  });
  return _makeRequest('get', 'gethoptfiles', {
    params: params_no_null
  })
}

const get_judgment = function (lang, abbr, year, num) {
  // Case.vue
  return _makeRequest('get', 'getjudgment', {
    params: {lang: lang, abbr: abbr, year: year, num: num}
  })
}

const get_metahopt = function (dbcat, abbr, lang) {
  // TreatyDb.vue
  return _makeRequest('get', 'getmetahopt', {
    params: {dbcat: dbcat, abbr: abbr, lang: lang}
  })
}

const get_treaty = function (lang, abbr, year, num) {
  // Treaty.vue
  return _makeRequest('get', 'gettreaty', {
    params: {lang: lang, abbr: abbr, year: year, num: num}
  })
}

const get_pd = function (lang, num) {
  // Pd.vue
  return _makeRequest('get', `getpd/${lang}/other/pd/${num}`, {})
}

const get_histlaw = function (lang, abbr, year, num) {
  // Pdf.vue
  return _makeRequest('get', 'gethistlaw', {
    params: {lang: lang, abbr: abbr, year: year, num: num}
  })
}

const get_other = function (lang, abbr, year, num) {
  // Pdf.vue
  return _makeRequest('get', 'getother', {
    params: {lang: lang, abbr: abbr, year: year, num: num}
  })
}

const compareCapSection = function (params) {
  return _makeRequest('get', 'cap/section/compare/', {
    params: params
  })
}

const sendFeedback = function (payload) {
  return _makeRequest('post', 'feedback', payload)
}

const sendComment = function (payload) {
  return _makeRequest('post', 'rating', payload)
}

const get_casenoteup = function (abbr, year, num) {
  // SearchResults.vue
  return _makeRequest('get', 'getcasenoteup', {
    params: {abbr: abbr, year: year, num: num}
  })
}

const get_legisnoteup = function (lang, capnum, subpath=null) {
  // SearchResults.vue
  return _makeRequest('get', 'getlegisnoteup', {
    params: {lang: lang, capnum: capnum, subpath: subpath}
  })
}

// for synopsis
const get_judgment_tags = function(neutral) {
  const _data = {params: {neutral: neutral}}
  return new Promise((resolve, reject) => {
    const res = synopsis_backend.get('api/get-judgment-tags', _data, {})
    res.then(res2 => {
      resolve(res2.data)
    }, err => {
      console.error(err)
      reject(err)
    })
  })
}

const get_ranked_judgment_by_tags = function(target_tags, exclusion_tags){
  var params = new URLSearchParams()
  target_tags.forEach(tagName => params.append('target_tags', tagName))
  exclusion_tags.forEach(tagName => params.append('exclusion_tags', tagName))
  params
  return new Promise((resolve, reject) => {
    const res = synopsis_backend.get('api/get-ranked-judgment-by-tags', {
      params: params
    }, {})
    res.then(res2 => {
      resolve(res2.data)
    }, err => {
      console.error(err)
      reject(err)
    })
  })
}

const get_info_box = function(neutral){
  const _data = {params: {neutral: neutral}}
  return new Promise((resolve, reject) => {
    const res = synopsis_backend.get('api/get-info-box', _data, {})
    res.then(res2 => {
      resolve(res2.data)
    }, err => {
      console.error(err)
      reject(err)
    })
  })
}

const get_summary_availability = function(neutral){
  const _data = {params: {neutral: neutral}}
  return new Promise((resolve, reject) => {
    const res = synopsis_backend.get('api/get-summary-availability', _data, {})
    res.then(res2 => {
      resolve(res2.data)
    }, err => {
      console.error(err)
      reject(err)
    })
  })
}

export default {
  get_latest,
  autocomplete,
  get_legisfiles,
  get_legisname,
  get_cap,
  get_related_caps,
  get_capversions,
  get_secversions,
  get_capversiontoc,
  get_sectionnav,
  get_capsection,
  advanced_search,
  simple_search,
  get_appeal_history,
  get_metalegis,
  get_metacase,
  get_casefiles,
  get_hoptfiles,
  get_judgment,
  get_treaty,
  get_pd,
  get_histlaw,
  get_other,
  get_metahopt,
  compareCapSection,
  sendFeedback,
  sendComment,
  get_casenoteup,
  get_legisnoteup,
  get_judgment_tags,
  get_ranked_judgment_by_tags,
  get_info_box,
  get_summary_availability,
}